import { Typography, Button, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Box, Tooltip, IconButton } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { currencyFormat, dateFormat } from "../../app/util/util";
import usePayments from "../../app/hooks/usePayments";
import AppPagination from "../../app/components/AppPagination";
import { useAppDispatch } from "../../app/store/configureStore";
import { getAxiosParamsForExport, removePayment, setPageNumber } from "../payments/paymentSlice";
import { useState } from "react";
import PaymentForm from "./PaymentForm";
//import { Product } from "../../app/models/product";
import agent from "../../app/api/agent";
import { LoadingButton } from "@mui/lab";
import { Payment } from "../../app/models/payment";
import { exportToCsv, exportToExcel } from "../../app/util/exportFile";
import { paymentExportFields } from "../../app/util/exportSettings";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PaymentFilterDrawer from "./PaymentFilterDrawer";
import { hasAdminOrWriteRole } from "../auth/authSlice";

export default function Payments() {
    const { payments, metaData, paymentParams } = usePayments();
    const dispatch = useAppDispatch();
    const [editMode, setEditMode] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState<Payment | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [target, setTarget] = useState("");

    function handleSelectPayment(payment: Payment) {
        setSelectedPayment(payment);
        setEditMode(true);
    }

    function handleDeletePayment(id: string) {
        setLoading(true);
        setTarget(id);
        agent.Payment.delete(id)
            .then(() => dispatch(removePayment(id)))
            .catch(error => console.log(error))
            .finally(() => setLoading(false));
    }

    function cancelEdit() {
        if (selectedPayment) setSelectedPayment(undefined);
        setEditMode(false);
    }

    function noWrapAndMinWidth() {
        return { whiteSpace: 'nowrap', maxWidth: 5 };
    }

    function noWrap() {
        return { whiteSpace: 'nowrap' };
    }


    function exportData() {
        let paymentsForExport: any;
        agent.Payment.getFilteredForExport('', getAxiosParamsForExport(paymentParams))
            .then(data => {
                paymentsForExport = data.items;
            })
            .catch(error => console.log(error))
            .finally(() => {
                exportToExcel(`Payments`, paymentExportFields, paymentsForExport);
            });
    }

    if (editMode) return <PaymentForm payment={selectedPayment} cancelEdit={cancelEdit} />

    return (
        <>
            <Box display='flex' justifyContent='space-between'>
                <Typography variant='h5' sx={{ letterSpacing: '1px' }}>Payments  ({metaData?.totalCount || 0})</Typography>
                <Box sx={{ alignItems: 'right' }}>
                    <PaymentFilterDrawer />
                    <Tooltip title="Export to Excel" placement="top">
                        <IconButton
                            size='large'
                            color='inherit'
                            onClick={exportData}
                            sx={{ ml: 'auto', fontSize: '2rem' }}
                        ><CloudDownloadIcon /></IconButton>
                    </Tooltip>
                    {hasAdminOrWriteRole() && <Tooltip title="Create Record" placement="top">
                        <IconButton
                            size='large'
                            color='inherit'
                            onClick={() => setEditMode(true)}
                            sx={{ ml: 'auto' }}
                        ><AddCircleIcon /></IconButton>
                    </Tooltip>}
                </Box>
            </Box>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead sx={noWrap} >
                        <TableRow>
                            {hasAdminOrWriteRole() && <TableCell align="center">Actions</TableCell>}
                            <TableCell align="center" style={{ display: 'none' }}>Id</TableCell>
                            <TableCell align="center" style={{ display: 'none' }}>TransactionId</TableCell>
                            <TableCell align="center">TranId</TableCell>
                            <TableCell align="center">PaymentDate</TableCell>
                            <TableCell align="center">PaymentMethod</TableCell>
                            <TableCell align="center">Amount</TableCell>
                            <TableCell align="center">Notes</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody sx={noWrap}  >
                        {payments.map((payment) => (
                            payment.id &&
                            <TableRow
                                key={payment.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                {hasAdminOrWriteRole() && <TableCell sx={noWrapAndMinWidth} align="center">
                                    <Button style={{ padding: 0 }} onClick={() => handleSelectPayment(payment)} startIcon={<Edit />} />
                                    <LoadingButton
                                        style={{ padding: 0 }}
                                        loading={loading && target === payment.id}
                                        startIcon={<Delete />}
                                        color='error'
                                        onClick={() => handleDeletePayment(payment.id || '')}
                                    />
                                </TableCell>}
                                <TableCell component="th" scope="row" style={{ display: 'none' }}>
                                    {payment.id}
                                </TableCell>
                                <TableCell component="th" scope="row" style={{ display: 'none' }}>
                                    {payment.transactionId}
                                </TableCell>
                                <TableCell align="center">{payment.tranId || ''}</TableCell>
                                <TableCell sx={noWrap} align="center">{dateFormat(payment.paymentDate?.toString() || '')}</TableCell>
                                <TableCell align="center">{payment.paymentMethod || ''}</TableCell>
                                <TableCell align="center">{currencyFormat(payment.amount || 0)}</TableCell>
                                <TableCell align="center">{payment.notes || ''}</TableCell>
                                
                                
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {metaData &&
                <Box sx={{ pt: 2 }}>
                    <AppPagination
                        metaData={metaData}
                        onPageChange={(page: number) => dispatch(setPageNumber({ pageNumber: page }))}
                    />
                </Box>
            }
        </>
    )
}